/* BeautyCorner — Sephora-style filter enhancements on top of the theme's native filtering.
 * - "Show more / less" on long filter groups (state survives the theme's AJAX re-render)
 * - Live brand search inside the Brand group (accent-insensitive)
 * - Quick-filter pills: toggle the matching sidebar checkbox, so the theme's own
 *   filter pipeline (URL, AJAX render, drawer sync, active chips) does the work.
 * The theme re-renders the sidebar/drawer/grid by replacing innerHTML and its events
 * are internal, so everything is (re)bound from a MutationObserver.
 */
(function () {
  if (window.bcFiltersLoaded) return;
  window.bcFiltersLoaded = true;

  var expanded = {};
  var queries = {};

  // accents, case and punctuation ignored: "lor" finds L'Oréal, "estee" finds Estée Lauder
  function norm(s) {
    return (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9Ͱ-Ͽ]+/g, '');
  }

  function groupKey(ul) {
    var scope = ul.closest('[data-filter-sidebar]') ? 'sidebar' : ul.closest('[data-filter-drawer]') ? 'drawer' : 'other';
    return ul.getAttribute('data-bc-values') + '|' + scope;
  }

  // Liquid's url_encode: spaces become "+"
  function liquidEncode(s) {
    return encodeURIComponent(s).replace(/%20/g, '+');
  }

  // Brands beyond Shopify's 100-value limit arrive as a JSON list of names; build their
  // checkboxes from an existing item only when the shopper expands or searches the list.
  function materializeTail(ul, wrap) {
    if (ul.__bcTail) return;
    ul.__bcTail = true;
    var data = wrap.querySelector('script[data-bc-longtail]');
    var tpl = ul.querySelector('li.filter-item');
    if (!data || !tpl) return;
    var names;
    try { names = JSON.parse(data.textContent); } catch (e) { return; }
    var scope = groupKey(ul).split('|')[1];
    var existing = {};
    ul.querySelectorAll('input[data-filter-item-input]').forEach(function (i) { existing[i.value] = true; });
    var frag = document.createDocumentFragment();
    names.forEach(function (entry) {
      // "Vendor|count" (count is the vendor's live products in this collection)
      var cut = entry.lastIndexOf('|');
      var name = cut > 0 ? entry.slice(0, cut) : entry;
      var n = cut > 0 ? entry.slice(cut + 1) : '';
      if (!name || existing[name]) return;
      var li = tpl.cloneNode(true);
      var input = li.querySelector('input');
      var label = li.querySelector('label');
      var text = li.querySelector('.filter-item__label');
      var count = li.querySelector('.filter-item__count');
      var id = 'filter--filter.p.vendor--' + encodeURIComponent(name) + '--' + scope + '--bc';
      li.classList.add('bc-fv--extra');
      li.classList.remove('bc-fv--nomatch');
      li.setAttribute('data-bc-key', name.toLowerCase());
      input.value = name;
      input.checked = false;
      input.disabled = false;
      input.id = id;
      input.setAttribute('data-filter', 'filter.p.vendor=' + name);
      input.setAttribute('data-value-escaped', liquidEncode(name));
      if (label) {
        label.setAttribute('for', id);
        label.classList.remove('filter-item__content--disabled');
      }
      if (text) text.textContent = name;
      if (count) {
        if (n) count.textContent = '(' + n + ')';
        else count.remove();
      }
      frag.appendChild(li);
    });
    ul.appendChild(frag);
    // one A–Z run after the top brands: merge the long tail into the listed rest
    var rest = Array.prototype.slice.call(ul.querySelectorAll(':scope > li.bc-fv--extra'));
    rest.sort(function (a, b) {
      return norm(a.getAttribute('data-bc-key')).localeCompare(norm(b.getAttribute('data-bc-key')));
    });
    rest.forEach(function (li) { ul.appendChild(li); });
  }

  function bindGroup(ul) {
    if (ul.__bc) return;
    ul.__bc = true;
    var key = groupKey(ul);
    var wrap = ul.parentElement;
    var btn = wrap.querySelector('[data-bc-more]');
    var search = wrap.querySelector('[data-bc-filter-search]');
    var empty = wrap.querySelector('.bc-fsearch__empty');

    function setOpen(open) {
      if (open) materializeTail(ul, wrap);
      ul.classList.toggle('bc-open', open);
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    setOpen(!!expanded[key] || ul.hasAttribute('data-bc-more-open'));

    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var open = !ul.classList.contains('bc-open');
        expanded[key] = open;
        setOpen(open);
        if (!open) {
          var group = ul.closest('.filter-drawer__group');
          if (group && group.getBoundingClientRect().top < 0) group.scrollIntoView({ block: 'start' });
        }
      });
    }

    if (search) {
      var run = function () {
        queries[key] = search.value;
        var q = norm(search.value);
        if (q) materializeTail(ul, wrap);
        var shown = 0;
        ul.querySelectorAll('li.filter-item').forEach(function (li) {
          var match = !q || norm(li.getAttribute('data-bc-key')).indexOf(q) !== -1;
          li.classList.toggle('bc-fv--nomatch', !match);
          if (match) shown++;
        });
        ul.classList.toggle('bc-searching', !!q);
        if (btn) btn.hidden = !!q;
        if (empty) empty.hidden = shown > 0;
      };
      search.value = queries[key] || '';
      search.addEventListener('input', run);
      search.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') e.preventDefault(); // never submit the filter form
      });
      if (search.value) run();
    }
  }

  function findInput(name, value) {
    var all = document.querySelectorAll('input[data-filter-item-input]');
    var fallback = null;
    for (var i = 0; i < all.length; i++) {
      var input = all[i];
      if (input.name !== name || input.value !== value) continue;
      if (input.closest('[data-filter-sidebar]')) return input;
      fallback = fallback || input;
    }
    return fallback;
  }

  function bindPill(pill) {
    if (pill.__bc) return;
    pill.__bc = true;
    pill.addEventListener('click', function () {
      var raw = pill.getAttribute('data-bc-pill');
      var cut = raw.indexOf('=');
      var input = findInput(raw.slice(0, cut), raw.slice(cut + 1));
      if (!input) return;
      input.checked = !input.checked;
      pill.setAttribute('aria-pressed', input.checked ? 'true' : 'false');
      pill.classList.add('is-loading');
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function enhance() {
    document.querySelectorAll('ul[data-bc-values]').forEach(bindGroup);
    document.querySelectorAll('[data-bc-pill]').forEach(bindPill);
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      enhance();
    });
  }

  function start() {
    enhance();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
